import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the WidgetRightChartEnps state domain
 */

const selectWidgetRightChartEnpsDomain = (state) =>
  state.get("widgetRightChartEnps", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsLoading = () =>
  createSelector(selectWidgetRightChartEnpsDomain, (state) =>
    state.get("isLoading")
  )

export const makeSelectDataEnps = () =>
  createSelector(selectWidgetRightChartEnpsDomain, (state) =>
    state.get("dataEnps")
  )

const makeSelectWidgetRightChartEnps = () =>
  createSelector(selectWidgetRightChartEnpsDomain, (substate) =>
    substate.toJS()
  )

export default makeSelectWidgetRightChartEnps
export { selectWidgetRightChartEnpsDomain }
